import React, {useEffect, useState} from "react";
import {
    useCreateChatClient,
    Chat,
    Channel,
    ChannelHeader,
    MessageComposer,
    MessageList,
    Thread,
    Window,
} from "stream-chat-react";
import {
    Fab,
    Paper,
    IconButton,
    Box,
    Typography,
    Collapse,
} from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";
import { type User, Channel as StreamChannel } from "stream-chat";
import {useChat} from "../hooks/use-chat";

const StreamChat = ({}) => {
    const client = useChat()
    const [channel, setChannel] = useState<StreamChannel>();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!client) return;

        const channel = client.channel("messaging", "ff_general_test", {
            // @ts-ignore
            name: "FF General",
        });

        setChannel(channel);
    }, [client]);

    if (!client) return <>  </>
    return (
        <>
            {!open && (
                <Fab
                    color="primary"
                    onClick={() => setOpen(true)}
                    sx={{
                        position: "fixed",
                        bottom: 24,
                        right: 24,
                        zIndex: (theme) => theme.zIndex.tooltip,
                    }}
                >
                    <ChatIcon />
                </Fab>
            )}

            <Collapse
                in={open}
                sx={{
                    position: "fixed",
                    bottom: 24,
                    right: 24,
                    zIndex: (theme) => theme.zIndex.modal,
                }}
            >
                <Paper
                    elevation={12}
                    sx={{
                        width: 380,
                        height: 600,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        borderRadius: 3,
                    }}
                >
                    <Box
                        sx={{
                            px: 2,
                            py: 1.5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            borderBottom: 1,
                            borderColor: "divider",
                        }}
                    >
                        <Typography variant="h6">
                            Chat
                        </Typography>

                        <IconButton onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box sx={{ flex: 1, minHeight: 0 }}>
                        <Chat client={client}>
                            <Channel channel={channel}>
                                <Window>
                                    <MessageList />
                                    <MessageComposer />
                                    <Thread />
                                </Window>
                            </Channel>
                        </Chat>
                    </Box>
                </Paper>
            </Collapse>
        </>
    )
}

export default StreamChat
